import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { getRedirectLinkToPackage } from '@karma/utils/functions/redirectLink';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@karma/components';
import CardMaker from '@karma/components/CardMaker';
import { ThemeContext } from 'styled-components';
import { REF_SOURCES } from 'consts/referralSources';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import onErrorImageHandler from 'functions/onErrorImageHandler';
import { DEFAULT_NEW_SALES } from 'consts/defaultImages';
import { EFFECT, THRESHOLD } from 'consts/lazyLoadParams';
import CustomPlaceholder from 'components/atoms/CustomPlaceholder/CustomPlaceholder';
import { getUserId } from 'store/user/selectors';
import HeightController from 'components/atoms/HeightController/HeightController';
import { newSalesCardInformationConfig } from './config';
import {
  BrandImage,
  CardContainer,
  ImageContainer,
  MakerContainer,
  StyledStoreLogo,
  StyledTypography,
} from './CardSales.style';

const CardSales = ({ newSale }) => {
  const {
    ad_package_id: packageId,
    retailer_name: retailerName,
    stake,
    preview_image_uri: imageUri,
    logo_image_uri: logoUri,
    dashboard_image_h2_text: description,
    media_type: mediaType,
  } = newSale;

  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const { color } = useContext(ThemeContext);

  const userId = useSelector(getUserId);

  const redirectLink = getRedirectLinkToPackage({
    packageId,
    userId,
    ruleName: retailerName,
    source: REF_SOURCES.dashboard,
    cashback: !!(userId && stake),
  });

  return (
    <CardContainer
      target="_blank"
      rel="nofollow"
      href={redirectLink}
      {...contextDataAttrs}
      data-alooma-element={ALOOMA.ELEMENTS.REDIRECT_LINK_TO_PACKAGE}
    >
      <ImageContainer direction="column" alignItems="flex-start" justifyContent="flex-start">
        <BrandImage
          onError={onErrorImageHandler}
          alt={retailerName}
          src={imageUri !== null ? imageUri : DEFAULT_NEW_SALES}
          data-error-src={DEFAULT_NEW_SALES}
          placeholder={<CustomPlaceholder />}
          effect={EFFECT}
          threshold={THRESHOLD}
        />

        <HeightController itemRelativeHeight={85} />

        <MakerContainer direction="column" spacing={8} alignItems="flex-start">
          {!!mediaType && <CardMaker rounding="right">{t(`app:${mediaType}`)}</CardMaker>}
          {!!stake && <CardMaker rounding="right">{t('app:earnKarmaCashShort', { percent: stake })}</CardMaker>}
        </MakerContainer>
        <StyledStoreLogo src={logoUri} alt={retailerName} />
      </ImageContainer>

      <Stack direction="column" alignItems="flex-start" justifyContent="flex-start" spacing={8} fullWidth>
        <Typography variant="labelMedium" noWrap color={newSalesCardInformationConfig[color].title}>
          {retailerName}
        </Typography>
        {!!description && (
          <StyledTypography variant="h6" color={newSalesCardInformationConfig[color].description}>
            {description}
          </StyledTypography>
        )}
      </Stack>
    </CardContainer>
  );
};

export default CardSales;
